<template>
  <v-expansion-panels
    v-model="expanded"
    class="Warnings v-expansion-panels--custom"
  >
    <v-expansion-panel :class="[{ bg: !noBackground }, 'Warnings_panel']">
      <v-expansion-panel-header>
        <h3 class="Warnings_title">
          ⚠️
          {{ $tc('warnings.title', warningsCount) }}
          <span class="warningCount"> ({{ warningsCount }}) </span>
        </h3>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <ul
          v-if="list.length"
          class="Warnings_list"
        >
          <li
            v-for="(section, index) in list"
            :key="`index${index}`"
            class="Warnings_row"
          >
            <div>
              {{ section.label }} :
              <span class="font-weight-bold">
                {{ $t('warnings.percentage', section.percent, { percent: section.percent.toFixed(0) }) }}
              </span>
            </div>
            <div v-if="section.percent === 100">
              <v-icon
                small
                color="#00D367"
                right
                dark
              >
                mdi-check-bold
              </v-icon>
            </div>
            <div v-else>
              <div
                v-if="Object.keys(section).length && section.key === 'documents'"
                class="link"
                @click="goToTab(section.tabId)"
              >
                <span class="text-decoration-underline">
                  {{ $tc('warnings.missing-docs', section.count) }}
                </span>
                <v-icon
                  small
                  color="#009ee0"
                  right
                  dark
                >
                  mdi-arrow-right
                </v-icon>
              </div>
              <div
                v-else
                class="link"
                @click="goToTab(section.tabId)"
              >
                <span class="text-decoration-underline">
                  {{ $tc('warnings.missing-infos', section.count) }}
                </span>
                <v-icon
                  small
                  color="#009ee0"
                  right
                  dark
                >
                  mdi-arrow-right
                </v-icon>
              </div>
            </div>
          </li>
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    props: {
      warnings: {
        type: Object,
        required: true,
      },
      noBackground: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        expanded: 1,
      }
    },
    computed: {
      warningsCount() {
        const sections = Object.keys(this.warnings)
        let count = 0
        sections.forEach((section) => {
          count += this.warnings[section].count
        })

        return count
      },
      list() {
        const sections = Object.keys(this.warnings)

        const res = []
        if (!sections.length) return res
        sections.forEach((section, index) => {
          res.push({
            key: section,
            tabId: index,
            label: this.$t(`warnings.sections.${section}`),
            count: this.warnings[section].count,
            percent: this.warnings[section].percent,
          })
        })

        return res
      },
    },
    methods: {
      goToTab(id) {
        this.$emit('selectTab', id)
      },
    },
  }
</script>

<style scoped lang="scss">
@import '~@/styles/app.scss';

.Warnings {
  font-size: 1rem;
  &_panel {
    border-radius: 8px;
  }
  .v-expansion-panel {
    background: unset !important;
  }

  .bg {
    background: $color-255_190_79_16 !important;
  }

  &_title {
    font-weight: $font-weight-600;
    padding: 5px;
    cursor: pointer;
    .warningCount {
      color: $color-009ee0;
    }
  }

  &_list {
    padding: 0;
  }

  &_row {
    padding: 5px;
    list-style: none;
    display: flex;
    justify-content: space-between;
  }

  &_fieldLabel {
    font-weight: $font-weight-600;
  }
  .link {
    cursor: pointer;
    color: $color-009ee0 !important;
  }
}
</style>
